import React from 'react';
import { useOutletContext } from 'react-router-dom';

const DecisionTreePanel = React.lazy(() => import('./DecisionTreePanel'));

export default function DecisionTreeFull(){
    const { update } = useOutletContext();
    React.useEffect(()=>{
        update({
            disableHeader: true
        })
    },[]);

    return (
        <DecisionTreePanel disableHeader/>
    )
}